import {all, call, put, takeLatest} from 'redux-saga/effects';
import {
  getCurrencyList,
  setCurrencyList,
  setCurrencyListError
} from "../../reducers/currencyReducer/currencyReducer";
import {API} from "../../../API/API";
import {BillingApiCurrencyListRequest, BillingApiCurrencyListResponse, PageModel} from "../../../proto/generated/api_entities_pb";
import {InitialPage} from "../../../utils/constans/pagination/pagination";
import {DebounceSelectOptionProps} from "../../../components/UI/AntCustom/DebounceSelect";

function* getCurrencyListSaga() {
  try {
    // Загружаем все валюты без фильтрации (пустой query) с большим лимитом
    const req = new BillingApiCurrencyListRequest()
      .setQuery('')
      .setPagemodel(
        new PageModel().setPage(InitialPage).setLimit(10000) // Большой лимит для загрузки всех валют
      );
    
    const res: BillingApiCurrencyListResponse = yield call(API.getCurrencyList, req);
    
    const currencies: DebounceSelectOptionProps[] = res.getCurrenciesList().map(currency => ({
      key: currency.getCurrencyid(),
      label: currency.getName(),
      value: currency.getCurrencyid(),
    }));
    
    yield put(setCurrencyList({currencies}));
  } catch (error: any) {
    yield put(setCurrencyListError({
      errorMessage: error?.message || 'Failed to load currencies'
    }));
  }
}

export function* currencySaga() {
  yield all([
    takeLatest(getCurrencyList.type, getCurrencyListSaga),
  ]);
}
